<h3 mat-dialog-title>{{data.title}}</h3>
<!-- <p>{{data.message}}</p> -->
<mat-dialog-content>
    <div [innerHTML]="data.message"></div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="onCancle()" class="second-btn" [hidden]="!data.cancleCallback">{{'gen_dialog_btn_cancle' | translate}}</button>
    <button mat-button cdkFocusInitial class="first-btn" (click)="onConfirm()">{{okBtnLabel}}</button>
</mat-dialog-actions>